import { Clock } from '@phosphor-icons/react';

export default Clock;